


































import { Emit, Prop, VModel, Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import resetPassword from "@/account/reset-password/reset-without-mail-validation";

@Component
export default class SetPasswordUserDialog extends Vue {
  @VModel({ type: Boolean }) open;
  @Prop() user;

  @Emit()
  onSuccess() {}

  async onSave() {
    if (!this.user.newPassword) {
      this.$bvToast.toast('Vui lòng nhập đủ các trường', {
        toaster: 'b-toaster-top-center',
        title: 'Thiếu thông tin',
        variant: 'info',
        solid: true,
        autoHideDelay: 5000,
      });
      return;
    }
    let rs = await resetPassword(this.user.login, this.user.newPassword);
    if (rs === 'SUCCESS') {
      this.$bvToast.toast('Đổi mật khẩu thành công', {
        toaster: 'b-toaster-top-center',
        title: 'Thành công',
        variant: 'success',
        solid: true,
        autoHideDelay: 5000,
      });
      this.onSuccess();
      this.open = false;
    } else {
      this.$bvToast.toast('Đã có lỗi xảy ra: ' + rs, {
        toaster: 'b-toaster-top-center',
        title: 'Lỗi',
        variant: 'warning',
        solid: true,
        autoHideDelay: 5000,
      });
    }
  }
}
